import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { PurpleButton } from "../../../components/buttons/purpleButton";
import { IStore } from "../../../model/store";
import { StoreCard } from "../../categories/components/storeCard";
import conveniadoService from "../../../services/conveniadoService";
import { goToPath } from "../../../utils/pageUtils";
import textUtils from "../../../utils/textUtils";
import {
  BasicCardWrapper,
  Container,
  GestaoConveniadosContainer,
} from "../cardDescontos/style";

export const CardConveniados = () => {
  const GET_CONVENIADOS_ERROR_MESSAGE =
    "Ocorreu um erro ao obter os conveniados. Por favor, tente novamente.";

  const toast = useRef<Toast>(null);
  const [conveniados, setConveniados] = useState<Array<IStore>>([]);

  useEffect(() => {
    conveniadoService
      .getAllConveniados({ filter: "", page: 0, size: 4 })
      .then((res) => {
        const items = Array.isArray(res.data?.content)
          ? res.data.content.slice(0, 4)
          : [];
        setConveniados(items);
      })
      .catch((err) => {
        console.error("Erro ao obter conveniados:", err);
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: GET_CONVENIADOS_ERROR_MESSAGE,
          life: 3000,
        });
      });
  }, []);

  return (
    <>
      <Toast ref={toast} />
      {conveniados.length > 0 ? (
        <>
          <Container>
            <h1 style={{ maxWidth: "700px" }}>
              {textUtils.handleTextHigliht("Confira nossos %Conveniados%")}
            </h1>
            <PurpleButton
              title="Ver mais"
              onClick={() => goToPath("/parceiros")}
            />
          </Container>
          <GestaoConveniadosContainer>
            <BasicCardWrapper>
              {conveniados.map((store) => (
                <StoreCard
                  key={store.id}
                  id={store.id}
                  nome={store.nome}
                  modalidade={store.modalidade}
                  endereco={store.endereco ?? ""}
                  descricao={store.descricao ?? ""}
                  instagram={store.instagram ?? ""}
                  site={store.site ?? ""}
                  imagem={store.imagem}
                />
              ))}
            </BasicCardWrapper>
          </GestaoConveniadosContainer>
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};
